// 当雷达图表准备完毕时的事件
export const LIDAR_CHART_READY = 'lidar-chart-ready'

// 当雷达图表准备销毁时的事件
export const LIDAR_CHART_DESTROY = 'lidar-chart-destroy'

// 当数据选中时的事件
export const LIDAR_CHART_DATA_SELECTED = 'lidar-chart-data-selected'

// 当数据取消选中的事件
export const LIDAR_CHART_DATA_CANCEL_SELECT = 'lidar-chart-data-cancel-select'

// 移动图表事件
export const LIDAR_CHART_MOVED = 'lidar-chart-moved'



// WEBPACK FOOTER //
// ./src/components/Data/Charts/LidarChart/EventKeys.js